import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpUrlGenerator } from "@ngrx/data";
import { ApiResponse, RestService } from "@recore-solutions/nstar-lib";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { NstarDataService } from "src/app/nstar-data.service";
import { environment } from "src/environments/environment";
import { ListingMediaAudit } from "./listing-media-audit";

@Injectable({
	providedIn: "root",
})
export class ListingMediaAuditDataService extends NstarDataService<ListingMediaAudit> {
	constructor(
		protected httpClient: HttpClient,
		protected httpUrlGenerator: HttpUrlGenerator,
		protected restService: RestService
	) {
		super("ListingMediaAudit" as never, httpClient, httpUrlGenerator);
	}

	getListingMediaAuditApiResponse(
		queryParams?: Record<string, any>
	): Observable<ListingMediaAudit[]> {
		const params = this.queryParamsToHttpParams(queryParams);
		return this.restService
			.get<ApiResponse<ListingMediaAudit>>(environment.endpoints.mediaHistory, params)
			.pipe(
				map((response) => response?.records || []),
				catchError(() => of([]))
			);
	}

	getAll(): Observable<ListingMediaAudit[]> {
		return this.getListingMediaAuditApiResponse();
	}

	getWithQuery(params: Record<string, any>): Observable<ListingMediaAudit[]> {
		return this.getListingMediaAuditApiResponse(params);
	}
}
